/* Store features: reviews link, cart drawer one-tap services. Independent of festival themes. */
(function () {
  if (window.__nvFeatures) return;
  window.__nvFeatures = true;

  /* stars on the product page -> scroll to the reviews */
  function goReviews(e) {
    var t = e.target.closest && e.target.closest('[data-nv-reviews-link]');
    if (!t) return;
    var el = document.getElementById('nv-reviews');
    if (!el) return;
    e.preventDefault();
    el.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
  document.addEventListener('click', goReviews);
  document.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') goReviews(e); });

  /* cart drawer: one-tap "+ Lab Certificate / + Energised" */
  function addService(btn) {
    if (btn.disabled) return;
    btn.disabled = true;
    var old = btn.innerHTML;
    btn.textContent = 'Adding...';
    var root = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/');
    var xhr = new XMLHttpRequest(); // plain XHR on purpose: no festival animation inside the drawer
    xhr.open('POST', root + 'cart/add.js');
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.onload = function () {
      if (xhr.status >= 200 && xhr.status < 300) {
        if (window.nvRefreshCart) window.nvRefreshCart();
      } else {
        btn.innerHTML = old; btn.disabled = false;
      }
    };
    xhr.onerror = function () { btn.innerHTML = old; btn.disabled = false; };
    xhr.send(JSON.stringify({ items: [{ id: Number(btn.getAttribute('data-id')), quantity: 1, properties: { 'For Product': btn.getAttribute('data-for') } }] }));
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-nv-upsell]');
    if (b) { e.preventDefault(); addService(b); }
  });
})();
